import { IRepoErrors } from "../errors";
import { http } from "../http";

export class PauseOrdersForOutletError extends Error {
  errors: IRepoErrors;

  constructor(errors: IRepoErrors) {
    super("Error in repo: pauseOrdersForOutlet");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

const serviceMap = {
  delivery: "delivery",
  pickup: "pickup",
  dinein: "dine-in",
};

export async function pauseOrdersForOutlet(
  outletId: string,
  service: keyof typeof serviceMap,
  endsAt: Date
): Promise<boolean> {
  try {
    await http.post(
      `/api/v3/outlets/${outletId}/ordering-services/${serviceMap[service]}/pause`,
      {
        ends_at: endsAt.toJSON(),
      }
    );
  } catch (e: any) {
    const error: IRepoErrors<null> = {};
    const isAxiosError = Boolean(e?.isAxiosError);

    if (!isAxiosError) {
      throw e;
    }

    throw new PauseOrdersForOutletError(error);
  }

  return true;
}
